<script setup lang="ts">
import { ActionCard } from '@dashhudson/dashing-ui/action-card';

import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type { CustomerSupportWidgetData } from '@/components/VisionAi/widgets/visionWidget.types';
import { useSupportChatStore } from '@/stores/support-chat';
import { useVisionAiStore } from '@/stores/vision-ai';

defineProps<{
  widgetData: CustomerSupportWidgetData;
}>();

const emit = defineEmits<{
  onWidgetClick: [interaction: string];
}>();

const visionAiStore = useVisionAiStore();
const supportChatStore = useSupportChatStore();

function handleCtaClick() {
  emit('onWidgetClick', VISION_AI_SUMMARY_INTERACTIONS.CUSTOMER_SUPPORT);
  visionAiStore.closeChatWindow();
  supportChatStore.show();
}
</script>

<template>
  <ActionCard
    variant="drawer"
    title="Customer Experience Chat"
    message="Need more help? Chat with our Customer Experience team now."
    :cta-button="{ label: 'Chat Now' }"
    :big-chip="{ icon: 'message-question' }"
    @cta-click="handleCtaClick"
  />
</template>
